import React from 'react';
import { FilterItem, ExternalAgreementFilterData } from '@/types';
import { Trans } from '@lingui/react/macro';
import { ExternalAgreementFilterValue } from '.';
import { useLingui } from '@lingui/react';
import { FilterDropDown, FilterPopOut } from '@ygtechnologies/bygr-frontend-component-library';

interface ExternalAgreementFilterProps {
    value: ExternalAgreementFilterValue;
    onFilterChange: (f: ExternalAgreementFilterValue) => void;
    filterData: ExternalAgreementFilterData | null;
    isOpen: boolean;
    onClose: () => void;
    hideStatuses?: boolean;
    onClear(): void;
}

const ExternalAgreementFilter: React.FC<ExternalAgreementFilterProps> = ({
    value,
    onFilterChange,
    filterData,
    isOpen,
    onClose,
    onClear,
    hideStatuses = false,
}) => {
    const { _ } = useLingui();
    const handleFilterChange = (changes: Partial<ExternalAgreementFilterValue>) => {
        onFilterChange({ ...value, ...changes });
    };

    if (!filterData) {
        return null;
    }

    const statuses: FilterItem[] = filterData.status.map((status) => {
        return {
            id: status,
            name: _({ id: `ExternalAgreementStatus.${status}` }),
        };
    });

    return (
        <FilterPopOut onClear={onClear} onClose={onClose} isVisible={isOpen}>
            <FilterDropDown
                data={filterData.groups}
                label={<Trans>Unit groups</Trans>}
                value={value.groups}
                onChange={(v) => handleFilterChange({ groups: v.map((v) => v.id) })}
            />

            <FilterDropDown
                data={filterData.units}
                label={<Trans>Units</Trans>}
                value={value.units}
                onChange={(v) => handleFilterChange({ units: v.map((v) => v.id) })}
            />

            {!hideStatuses && (
                <FilterDropDown
                    data={statuses}
                    label={<Trans>Status</Trans>}
                    value={value.statuses}
                    onChange={(v) => handleFilterChange({ statuses: v.map((v) => v.id) })}
                />
            )}
        </FilterPopOut>
    );
};

export default ExternalAgreementFilter;
